import { createBrowserRouter, Navigate, Link } from 'react-router';
import { LocaleLayout } from './layouts/LocaleLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { OwnerLayout } from './layouts/OwnerLayout';
import { RequireSession } from './guards/RequireSession';
import { RequireOwner } from './guards/RequireOwner';
import { LoginPage } from '../modules/auth/pages/LoginPage';
import { DashboardPage } from '../modules/dashboard/pages/DashboardPage';
import { AppointmentsPage } from '../modules/appointments/pages/AppointmentsPage';
import { CustomersPage } from '../modules/customers/pages/CustomersPage';
import { CustomerDetailPage } from '../modules/customers/pages/CustomerDetailPage';
import { CreateInvoicePage } from '../modules/invoices/pages/CreateInvoicePage';
import { InvoiceDetailPage } from '../modules/invoices/pages/InvoiceDetailPage';
import { InvoicesPage } from '../modules/invoices/pages/InvoicesPage';
import { CatalogPage } from '../modules/catalog/pages/CatalogPage';
import { StaffPage } from '../modules/staff/pages/StaffPage';
import { ExpensesPage } from '../modules/expenses/pages/ExpensesPage';
import { ExpenseTransactionsPage } from '../modules/expenses/pages/ExpenseTransactionsPage';
import { SettingsPage } from '../modules/settings/pages/SettingsPage';
import { OnlineBookingPage } from '../modules/online-booking/pages/OnlineBookingPage';
import { ReportsPage } from '../modules/reports/pages/ReportsPage';
import { useI18n } from '../shared/i18n/I18nProvider';
import { OwnerProviders } from './providers';
import { PublicBookingPage } from '../modules/public-booking/pages/PublicBookingPage';
import { EmptyState } from '../shared/ui';

function NotFoundPage() { const { t } = useI18n(); return <main><EmptyState title={t("Không tìm thấy trang")} description={t("Đường dẫn này không tồn tại trong Store-X Owner Web.")} action={<Link className="btn btn-primary" to="/login">{t("Về trang đăng nhập")}</Link>} /></main>; }
const workspaceRoutes = [
  { index: true, element: <Navigate to="dashboard" replace /> },
  { path: 'dashboard', element: <DashboardPage /> },
  { path: 'appointments', element: <AppointmentsPage /> },
  { path: 'customers', element: <CustomersPage /> },
  { path: 'customers/:customerId', element: <CustomerDetailPage /> },
  { path: 'invoices', element: <InvoicesPage /> },
  { path: 'invoices/new', element: <CreateInvoicePage /> },
  { path: 'invoices/:invoiceId', element: <InvoiceDetailPage /> },
  { path: 'services', element: <CatalogPage kind="services" /> },
  { path: 'categories', element: <CatalogPage kind="categories" /> },
  { path: 'combos', element: <CatalogPage kind="combos" /> },
  { path: 'staff', element: <StaffPage /> },
  { path: 'expenses', element: <ExpensesPage /> },
  { path: 'expenses/transactions', element: <ExpenseTransactionsPage /> },
  { path: 'settings', element: <SettingsPage /> },
  { path: 'online-booking', element: <OnlineBookingPage /> },
  { path: 'reports', element: <ReportsPage /> },
];
export const router = createBrowserRouter([
  { path: '/booking/:bookingCode/:language?', element: <PublicBookingPage /> },
  { path: '/booking', element: <PublicBookingPage /> },
  { path: '/demo-booking', element: <PublicBookingPage demo /> },
  { element: <OwnerProviders />, children: [{ element: <LocaleLayout />, children: [
  { path: '/', element: <Navigate to="/login" replace /> },
  { element: <AuthLayout />, children: [{ path: '/login', element: <LoginPage /> }] },
  { path: '/demo', element: <OwnerLayout />, children: workspaceRoutes },
  { element: <RequireSession />, children: [{ element: <RequireOwner />, children: [{ path: '/owner', element: <OwnerLayout />, children: workspaceRoutes }] }] },
  { path: '*', element: <NotFoundPage /> },
] }] }]);
